import styled, { StyledComponentBase } from 'styled-components'
import welcomeBg from './../../../assets/welcome/welcome_bg.png'
import welcomeBg2x from './../../../assets/welcome/welcome_bg@2x.png'
import welcomeBg3x from './../../../assets/welcome/welcome_bg@3x.png'

interface IBodyWelcome extends StyledComponentBase<any, {}> {
	Bg?: any
}

const BodyWelcome: IBodyWelcome = styled.main`
	position: relative;
	flex: 1;
	overflow: hidden;
	background: url(${welcomeBg}) no-repeat;
	background-size: cover;
	display: flex;
	justify-content: center;
	align-items: center;
	padding-bottom: 3rem;

	@media only screen and (-o-min-device-pixel-ratio: 5/4),
		only screen and (-webkit-min-device-pixel-ratio: 1.25),
		only screen and (min-device-pixel-ratio: 1.25),
		only screen and (min-resolution: 1.25dppx) {
		background: url(${welcomeBg2x});
		background-size: cover;
	}

	@media only screen and (-o-min-device-pixel-ratio: 5/4),
		only screen and (-webkit-min-device-pixel-ratio: 1.25),
		only screen and (min--moz-device-pixel-ratio: 1.25),
		only screen and (min-device-pixel-ratio: 1.25),
		only screen and (min-resolution: 1.25dppx) {
		background: url(${welcomeBg2x});
		background-size: cover;
	}

	@media only screen and (-o-min-device-pixel-ratio: 9/4),
		only screen and (-webkit-min-device-pixel-ratio: 2.25),
		only screen and (min-device-pixel-ratio: 2.25),
		only screen and (min-resolution: 2.25dppx) {
		background: url(${welcomeBg3x});
		background-size: cover;
	}
`

BodyWelcome.Bg = styled.img.attrs(() => {
	return {
		srcSet: `${welcomeBg}, ${welcomeBg2x}, ${welcomeBg3x}`,
		src: `${welcomeBg}`,
		alt: 'Pic',
	}
})`
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	object-fit: contain;
`

export { BodyWelcome }
